import { Box, InputLabel } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import TitleInput from "../../TitleInput";

const NameInput = ({ data, patchTitle }) => {
  const { t } = useTranslation();

  return (
    <Box my={2} id="name">
      <InputLabel shrink>{t("/editor.gui.marker_name")}</InputLabel>
      <TitleInput
        values={data?.title}
        markerData={data}
        patchFunction={patchTitle}
      />
    </Box>
  );
};

export default NameInput; 